var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('body'),expression:"'body'"},{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"scroll-to-top"},[_c('icon-arrow-up',{staticClass:"icon-arrow-up",attrs:{"width":"16","height":"18","icon-color":"#949494"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }